import MultiLevelDropdownMenu from '../../components/dropdown/MultiLevelDropdownMenu';

const siteNav = document.getElementById('site-nav');

if (siteNav) {
  // eslint-disable-next-line no-new
  new MultiLevelDropdownMenu(siteNav);
}
